export const outerWrapper = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'calc(100vh - 67px)',
    boxSizing: 'border-box',
    padding: '12px 16px',
    gap: 8,
};

export const heading = {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '24px',
    color: '#1e1e2d',
    flexShrink: 0,
};

export const container = {
    display: 'grid',
    gridTemplateColumns: 'minmax(500px, 55%) 1fr',
    gap: 16,
    paddingBottom: '30px',
    flex: 1,
    minHeight: 0,
};

export const leftPanel = {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #e9ebf5',
    backgroundColor: '#fff',
    borderRadius: 4,
    overflow: 'hidden',
    height: '100%',
    boxSizing: 'border-box',
};

export const tableWrapper = {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    minHeight: 0,
};

export const tableHeaderRow = {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e9ebf5',
    backgroundColor: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: 1,
};

export const tableHeaderCell = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '17px',
    color: '#454653',
    padding: '8px 12px',
    height: 40,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    borderRight: '1px solid #e9ebf5',
};

export const tableRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 12,
    borderBottom: '1px solid #e9ebf5',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
};

export const tableRowSelected = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: 12,
    cursor: 'pointer',
    border: '2px solid #3f51b5',
    borderRadius: 3,
};

export const radioCircle = {
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: '#eee',
    flexShrink: 0,
};

export const radioCircleSelected = {
    width: 18,
    height: 18,
    borderRadius: '50%',
    backgroundColor: '#3f51b5',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const rowContent = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
};

export const opportunityTitle = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '17px',
    color: '#5f6071',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
};

export const actionBySection = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: 240,
    flexShrink: 0,
    paddingLeft: 12,
    boxSizing: 'border-box',
};

export const avatarWrap = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    minWidth: 0,
};

export const avatar = {
    width: 22,
    height: 22,
    borderRadius: '50%',
    border: '1.5px solid rgba(255,255,255,0.8)',
    overflow: 'hidden',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 9,
    fontWeight: 600,
    color: '#fff',
    letterSpacing: 0.3,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
};

export const avatarName = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '17px',
    color: '#2b2c35',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};

export const paginationFooter = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 10px',
    borderTop: '1px solid #e9ebf5',
    flexShrink: 0,
    minHeight: 32,
};

export const paginationLeft = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
};

export const rowsPerPageLabel = {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    fontSize: 11,
    color: '#505763',
    whiteSpace: 'nowrap',
};

export const rowsPerPageSelect = {
    width: 56,
    height: 22,
    border: '1px solid #e9ebf5',
    borderRadius: 3,
    backgroundColor: '#fff',
    padding: '0 8px',
    fontFamily: "'Inter', sans-serif",
    fontSize: 11,
    color: '#000',
    outline: 'none',
    cursor: 'pointer',
    appearance: 'none',
    WebkitAppearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L4 4L7 1' stroke='%23505763' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 6px center',
};

export const paginationInfo = {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    fontSize: 11,
    color: '#505763',
    whiteSpace: 'nowrap',
};

export const paginationRight = {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
};

export const paginationButton = {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 3,
    backgroundColor: '#fff',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    color: '#505763',
    fontSize: 14,
};

export const noDataText = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    color: '#9e9e9e',
    textAlign: 'center',
    padding: '24px 0',
};

export const loadingWrapper = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
    backgroundColor: '#fff',
    borderRadius: 4,
    border: '1px solid #e9ebf5',
};

export const loadingText = {
    fontFamily: "'Roboto', sans-serif",
    fontSize: 13,
    color: '#78798e',
    fontWeight: 400,
};
